import { Star } from "lucide-react";

const testimonials = [
  {
    name: "Maria Popescu",
    location: "București",
    text: "Calitativ, mirosul mult mai bun decât mă așteptam. Curăță bine rufele albe! Recomand cu încredere!",
    rating: 5,
  },
  {
    name: "Andrei Ionescu",
    location: "Cluj-Napoca",
    text: "Îl folosesc de luni bune și sunt foarte mulțumit. Nu pătează, curăță eficient și miroase superb.",
    rating: 5,
  },
  {
    name: "Elena Dumitrescu",
    location: "Timișoara",
    text: "Pachetul XXL este o investiție excelentă. Am dat a doua comandă și voi continua să cumpăr!",
    rating: 5,
  },
  {
    name: "Cristian Mihai",
    location: "Iași",
    text: "Produs super OK, miros plăcut și curățare super bună. Merită banii fiecare leu cheltuit.",
    rating: 5,
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimoniale"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-white/60 backdrop-blur-sm"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-cyan-600 mb-3">
            Ce spun clienții
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-slate-900 leading-tight">
            Peste 3000 de familii<br />
            <span className="text-cyan-600">ne-au ales deja.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8">
          {testimonials.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="relative bg-sky-50 border border-sky-100 rounded-3xl p-7 md:p-8 hover:bg-white hover:border-cyan-200 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star
                    key={idx}
                    className="w-4 h-4 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed text-base md:text-lg font-medium">
                „{t.text}"
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-cyan-500 to-teal-500 flex items-center justify-center text-white font-heading font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="font-heading font-bold text-slate-900 text-sm">
                    {t.name}
                  </div>
                  <div className="text-xs text-slate-500">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
